<script>
import { getIconPath as getImgPath } from "@/utils/getCorrectPath";

export default {
  name: "CancellingReasonModal",

  data() {
    return {
      getImgPath: getImgPath,
      selected: [],
      otherText: "",
      toolsText: "",
      options: [],
    };
  },

  computed: {
    cancelOptions() {
      return [
        {
          value: "expensive",
          text: this.$t("account.cancelReasons.expensive"),
        },
        {
          value: "inaccurate",
          text: this.$t("account.cancelReasons.inaccurate"),
        },
        {
          value: "notEnoughSupport",
          text: this.$t("account.cancelReasons.notEnoughSupport"),
        },
        {
          value: "switchingToAnother",
          text: this.$t("account.cancelReasons.switchingToAnother"),
        },
        { value: "other", text: this.$t("account.cancelReasons.other") },
      ];
    },

    isOtherSelected() {
      return this.selected.includes("other");
    },

    isOtherTextValid() {
      return !this.isOtherSelected || this.otherText.trim().length > 0;
    },
  },

  watch: {
    selected() {
      this.setReason();
    },

    otherText() {
      this.setReason();
    },

    toolsText() {
      this.setReason();
    },
  },

  methods: {
    setReason() {
      if (!this.isOtherTextValid) {
        this.$emit("reasonSelected", {});
        return;
      }

      const reasons = this.selected.map((item) => {
        switch (item) {
          case "other":
            return {
              reason: "other",
              text: this.otherText,
            };
          case "switchingToAnother":
            return {
              reason: "switchingToAnother",
              text: this.toolsText,
            };
          default:
            return {
              reason: item,
            };
        }
      });

      this.$emit("reasonSelected", { reasons });
    },
  },
};
</script>

<template>
  <div
    id="cancelling_reason_modal"
    class="step-block"
    data-testid="cancelling_reason_modal"
  >
    <div class="img-content">
      <img
        v-if="getImgPath('cancelation')"
        :src="getImgPath('cancelation')"
        class="item-icon"
        alt="icon"
      />
    </div>

    <p>{{ $t("account.reasonForCancelling") }}</p>

    <eg-b-form-checkbox-group
      v-model="selected"
      name="reason"
      class="w-100"
      stacked
    >
      <eg-b-form-checkbox
        v-for="option in cancelOptions"
        :key="option.value"
        :value="option.value"
        class="w-100 mb-1"
      >
        {{ option.text }}
      </eg-b-form-checkbox>
    </eg-b-form-checkbox-group>

    <eg-b-form-group
      v-if="selected.includes('switchingToAnother')"
      :label="$t('account.cancelReasons.whichToolSwitching')"
      class="mt-2"
    >
      <eg-b-form-textarea
        v-model="toolsText"
        :placeholder="$t('account.cancelReasons.enterToolsName')"
        rows="3"
        no-resize
      />
    </eg-b-form-group>

    <eg-b-form-group
      v-if="selected.includes('other')"
      :label="$t('account.cancelReasons.pleaseWriteReason')"
      class="mt-2"
    >
      <eg-b-form-textarea
        v-model="otherText"
        :placeholder="$t('common.enter')"
        rows="1"
        no-resize
        :state="isOtherTextValid ? null : false"
      />
    </eg-b-form-group>
  </div>
</template>
